export const driList = [
  { label: 'Both', value: 'B' },
  { label: 'Direct', value: 'D' },
  { label: 'RI', value: 'R' }
]
